import { Padrao } from '../generic/padrao';

export class FiscalCstIpi extends Padrao{

    override idTab = 180;

    descricao: string;
    valor: string;
    tipo: string;
}
